import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

export default function ContributorTermsPage() {
  return (
    <div className="min-h-screen bg-surface flex flex-col">
      <SEO 
        title="Contributor Agreement"
        description="Terms and conditions for contributors on Strider - the remote workspace discovery platform."
        canonical="/contributor-terms"
      />
      <Header />
      
      <main className="flex-1 pt-24 pb-12 px-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Contributor Agreement</h1>
          <p className="text-gray-500 mb-8">Last updated: December 2025</p>

          <div className="prose prose-gray max-w-none space-y-6">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Who is a Contributor?</h2>
              <p className="text-gray-600">
                A "Contributor" is any user who submits reviews, ratings, venue suggestions, or other content 
                to the Strider platform. By contributing, you agree to the following terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Content Guidelines</h2>
              <p className="text-gray-600 mb-3">
                As a Contributor, you agree to:
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Submit honest, accurate, and helpful reviews based on genuine experiences</li>
                <li>Not post defamatory, offensive, or misleading content</li>
                <li>Not submit fake reviews or engage in review manipulation</li>
                <li>Not include personal attacks or discriminatory language</li>
                <li>Not post content that infringes on intellectual property rights</li>
                <li>Not use the platform for spam, advertising, or promotional purposes</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Content Ownership & Licence</h2>
              <p className="text-gray-600">
                You retain ownership of the content you submit. However, by submitting content to Strider, 
                you grant us a worldwide, non-exclusive, royalty-free licence to use, display, modify, and 
                distribute your content in connection with our services. This licence continues even if you 
                delete your account (for content already published).
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Gamification & Rewards</h2>
              <p className="text-gray-600 mb-3">
                Strider operates a points-based gamification system:
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Points are earned for genuine contributions (reviews, venue submissions)</li>
                <li>Points have no cash value and cannot be exchanged for money</li>
                <li>We reserve the right to adjust, remove, or reset points for any reason</li>
                <li>Attempting to game the system may result in point deductions or account suspension</li>
                <li>Monthly/yearly prizes are awarded at our discretion and may change without notice</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Account Termination</h2>
              <p className="text-gray-600">
                We reserve the right to suspend or terminate contributor accounts that violate these terms. 
                Upon termination, your reviews may be anonymised but remain on the platform. You may also 
                request account deletion through your profile settings, which will anonymise your contributions.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Moderation</h2>
              <p className="text-gray-600">
                All contributions are subject to moderation. We may edit, remove, or decline to publish 
                any content that violates our guidelines. Decisions regarding content moderation are final.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Privacy</h2>
              <p className="text-gray-600">
                Your contributor activities are subject to our <a href="/privacy" className="text-brand hover:underline">Privacy Policy</a>. 
                Your email address is used for account purposes and is not publicly displayed. Your username 
                and avatar will be shown alongside your contributions.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">8. Changes to This Agreement</h2>
              <p className="text-gray-600">
                We may update this agreement from time to time. Continued use of the contributor features 
                after changes constitutes acceptance of the updated terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">9. Contact</h2>
              <p className="text-gray-600">
                For questions about this agreement, please contact us at{" "}
                <a href="mailto:info@strider.work" className="text-brand hover:underline">info@strider.work</a>.
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
